<template>
<div class="row row-frame"
     :class="'row-frame-' + recordDiff.diffState">
    <div class="col container">
        <template v-if="recordDiff.diffState === 'changed'">
            <div class="row data-row old-data-row" ref="oldDataRow">
                <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.oldData.dateString }}</span></div>
                <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.oldData.productId }}</span></div>
                <div class="col-3 data-col"><span class="wrap-text">{{ recordDiff.oldData.productName }}</span></div>
                <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.oldData.areaAddress }}</span></div>
                <div class="col-2 data-col"><span class="wrap-text">{{ recordDiff.oldData.place }}</span></div>
                <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.oldData.resultCount }}</span></div>
                <div class="col-1 data-col"><span class="wrap-text">{{ fixedStr(recordDiff.oldData.sPrice) }}</span></div>
                <div class="col-1 data-col"><span class="wrap-text">{{ fixedStr(recordDiff.oldData.amount) }}</span></div>
                <div class="col-1 data-col"><span class="wrap-text state-text">変更前</span></div>
            </div>
            <div class="row arrow-row">
                <div class="arrow"></div>
            </div>
        </template>
        <div class="row data-row" ref="dataRow">
            <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.dateString }}</span></div>
            <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.productId }}</span></div>
            <div class="col-3 data-col"><span class="wrap-text">{{ recordDiff.productName }}</span></div>
            <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.areaAddress }}</span></div>
            <div class="col-2 data-col"><span class="wrap-text">{{ recordDiff.place }}</span></div>
            <div class="col-1 data-col"><span class="wrap-text">{{ recordDiff.resultCount }}</span></div>
            <div class="col-1 data-col"><span class="wrap-text">{{ fixedStr(recordDiff.sPrice) }}</span></div>
            <div class="col-1 data-col"><span class="wrap-text">{{ fixedStr(recordDiff.amount) }}</span></div>
            <div class="col-1 data-col"><span class="wrap-text state-text">{{ recordDiff.diffStateText }}</span></div>
        </div>
    </div>
</div>

</template>

<script lang="ts">
import {defineComponent, onMounted, PropType, ref} from "vue";
import {PostingRecordDiff} from "@/data-models/posting-record-diff";

export default defineComponent({
    name: "PostingRecordDiffRow",
    props: {
        recordDiff: {
            type: Object as PropType<PostingRecordDiff>,
            required: true
        }
    },
    setup(props) {

        const dataRow = ref<HTMLDivElement>(),
            oldDataRow = ref<HTMLDivElement>()

        const fixedStr = (num: number): string => {
            const decimal = props.recordDiff.diffState === "changed" ? 5 : 3
            return num.toFixed(decimal)
        }

        const updateDataRowHeight = (row: HTMLDivElement) => {
            let maxSpanHeight = 0
            const dataCols = row.children
            for (let i = 0; i < dataCols.length; i++) {
                const dataCol = dataCols.item(i)
                if (dataCol) {
                    const span = dataCol.children.item(0)
                    if (span) {
                        // console.log("span.clientHeight: ", span.clientHeight)
                        if (span.clientHeight > maxSpanHeight) {
                            maxSpanHeight = span.clientHeight
                        }
                        // (dataCol as HTMLDivElement).style.height = span.clientHeight + "px"
                    }
                }
            }
            row.style.height = maxSpanHeight + "px"
        }

        const waitAndUpdateHeights = () => {
            const timerId = window.setInterval(() => {
                if (dataRow.value) {
                    window.clearInterval(timerId)
                    updateDataRowHeight(dataRow.value)

                    if (oldDataRow.value) {
                        updateDataRowHeight(oldDataRow.value)
                    }
                }
            }, 50)
        }

        onMounted(() => {
            waitAndUpdateHeights()
        })

        let resizeTimerId = 0
        window.addEventListener("resize", () => {
            window.clearTimeout(resizeTimerId)
            resizeTimerId = window.setTimeout(() => {
                if (dataRow.value) {
                    updateDataRowHeight(dataRow.value)
                }

                if (oldDataRow.value) {
                    updateDataRowHeight(oldDataRow.value)
                }
            }, 300)
        })

        return {
            fixedStr,
            dataRow,
            oldDataRow,
        }
    }
})
</script>

<style scoped lang="scss">

.row-frame {
    position: relative;
    border-bottom: solid 1px lightgray;

    .arrow-row {
        position: relative;
        background-color: whitesmoke;
        height: 20px;

        .arrow {
            position: absolute;
            margin: 0 auto;
            top: 3px;
            left: 0;
            right: 0;
            width: 30px;
            height: 15px;

            border: none;
            border-top: 15px solid orange;
            border-left: 15px transparent solid;
            border-right: 15px transparent solid;

        }
    }

    .data-row {
        position: relative;
        min-height: 40px;

        .data-col {
            position: relative;
            border-left: solid 1px lightgray;
            height: auto;

            &:last-child {
                border-right: solid 1px lightgray;
            }

            //.wrap-text {
            //    background-color: red;
            //}
        }
    }

    &-added {
        border: solid 1px #006839;
        background-color: #6affbb;

        .state-text {
            color: #006839;
        }
    }

    &-deleted {
        border: solid 1px red;
        background-color: #FFBBBB;

        .data-row {
            :not(:last-child) {
                span {
                    text-decoration: line-through;
                }
            }
        }

        .state-text {
            color: red;
        }
    }

    &-changed {

        border: solid 1px darkgoldenrod;

        background-color: #ffc270;

        .state-text {
            color: darkgoldenrod;
        }

        .old-data-row {
            background-color: #FFE2BB;
        }
    }
}

</style>